import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M7.55804 18.01L6.14404 16.597L10.744 11.997L6.14404 7.40399L7.55804 5.98999L13.569 12L7.55904 18.01H7.55804ZM17.858 18H15.858V5.99999H17.858V18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LastPage"
);
